import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import MDButton from "components/Basics/MDButton";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SurveyForm from "./SurveyForm";
import { v4 as uuidv4 } from "uuid";

const DialogSurvey = ({
	onClose,
	onAddSurvey,
	menu,
	isEditMode,
	title = "Survey",
	isSolutionType = false
}) => {
	const { t } = useTranslation();
	const [formData, setFormData] = useState({
		question: "",
		option1: "",
		option2: "",
		option3: "",
		additionalOptions: []
	});
	const [isValid, setIsValid] = useState(false);

	useEffect(() => {
		setFormData({
			question: menu?.subject || "",
			option1: menu?.choices?.[0]?.label || "",
			option2: menu?.choices?.[1]?.label || "",
			option3: menu?.choices?.[2]?.label || "",
			additionalOptions: menu?.choices?.slice(3).map(choice => choice.label || "") || []
		});
	}, [menu]);

	const handleChange = e => {
		const { value } = e.target;
		setFormData(prevState => ({
			...prevState,
			...value
		}));
	};

	const handleFormValidity = valid => {
		setIsValid(valid);
	};

	const isEditing = isEditMode || Boolean(menu);

	return (
		<Dialog open onClose={() => onClose?.()}>
			<DialogTitle>
				{title}
				<IconButton
					edge="end"
					color="inherit"
					onClick={onClose}
					aria-label="close"
					style={{ float: "right" }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<SurveyForm
					formData={formData}
					onChangeForm={handleChange}
					onValidate={handleFormValidity}
					isSolutionType={isSolutionType}
				/>
			</DialogContent>
			<DialogActions>
				<MDButton variant="outlined" color="info" onClick={() => onClose?.()}>
					{t("SETTINGS.cancel")}
				</MDButton>
				<MDButton
					variant="contained"
					color="info"
					onClick={() => {
						const allOptions = [
							{
								label: formData.option1,
								value: isEditing && menu?.choices?.[0]?.value ? menu.choices[0].value : uuidv4()
							},
							{
								label: formData.option2,
								value: isEditing && menu?.choices?.[1]?.value ? menu.choices[1].value : uuidv4()
							},
							{
								label: formData.option3,
								value: isEditing && menu?.choices?.[2]?.value ? menu.choices[2].value : uuidv4()
							},
							...(formData.additionalOptions || []).map((label, index) => ({
								label,
								value:
									isEditing && menu?.choices?.[index + 3]?.value
										? menu.choices[index + 3].value
										: uuidv4()
							}))
						].filter(choice => choice.label.trim() !== "");

						const newSurvey = {
							menu: {
								subject: formData.question,
								choices: allOptions
							}
						};
						onAddSurvey(newSurvey);
						onClose?.();
					}}
					disabled={!isValid}
				>
					{t(isEditing ? "SETTINGS.edit" : "SETTINGS.add")}
				</MDButton>
			</DialogActions>
		</Dialog>
	);
};

export default DialogSurvey;
